import React from 'react';
import graphql from "babel-plugin-relay/macro";
import {createTaxonomyOptions} from "../../../helpers/utils";
import {useFragment, useMutation} from "react-relay";
import {allTaxonomiesDropdown} from "../../../relay/Fragments";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import FormModal from "../../../components/common/modals/FormModal";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";

const NewPractitionerLocationTaxonomyModal = ({showModal, onClose, practitionerLocationId, allTaxonomies}) => {
    const mutation = graphql`
    mutation NewPractitionerLocationTaxonomyModalMutation($practitionerLocationId: ID!, $taxonomyId: ID!, $seq: Int!, 
        $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
      practitionerLocation {
          createTaxonomy(input: {practitionerLocationId: $practitionerLocationId, taxonomyId: $taxonomyId, seq: $seq, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
              practitionerLocationTaxonomy {
                  id
                  practitionerLocation {
                      taxonomies {
                          ...PractitionerLocationTaxonomies_Taxonomy
                      }}}}}}`
    const taxonomies = createTaxonomyOptions(useFragment(allTaxonomiesDropdown, allTaxonomies));
    const [commitMutation, isInFlight] = useMutation(mutation);
    const defaultValues = {
        ...newBandDefaultValues,
        practitionerLocationId: practitionerLocationId,
        taxonomyId: '',
        seq:'0',
    }
    const schema = bandedSchema.shape({
        taxonomyId: yup.string().required("Taxonomy is required"),
        seq: yup.number().required("Seq is required")
    })
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)});
    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.practitionerLocation) {
                    toast.success("Taxonomy for Provider Location created")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"New Taxonomy"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormSelect options={taxonomies} controlId={"taxonomyId"} label={"Taxonomy"} />
            <HorizontalFormInput controlId={"seq"} label={"Seq"} type={"number"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
export default NewPractitionerLocationTaxonomyModal